import { setError } from "../Indicator";

import {
  // CLIENT_DASHBOARD_DELIVERED_COUNT,
  // CLIENT_DASHBOARD_UN_DELIVERED_COUNT,
  CLIENT_DASHBOARD_OFD_COUNT,
  // CLIENT_DASHBOARD_RTS_COUNT,
  CLIENT_DASHBOARD
} from "../../constants/url.constant";
import { API } from "../../api";

export const REQUEST_ORDER_COUNT_BY_STATUS = "REQUEST_ORDER_COUNT_BY_STATUS";
export const SET_DELIVERED_ORDER_COUNT = "SET_DELIVERED_ORDER_COUNT";
export const SET_UN_DELIVERED_ORDER_COUNT = "SET_UN_DELIVERED_ORDER_COUNT";
export const SET_RETURN_TO_SHIPPER_ORDER_COUNT =
  "SET_RETURN_TO_SHIPPER_ORDER_COUNT";

export const REQUEST_SHIPING_LIST_ORDER = "REQUEST_SHIPING_LIST_ORDER";
export const SET_SHIPING_LIST_ORDER = "SET_SHIPING_LIST_ORDER";
export const SET_SHIPING_LIST_UN_DELIVERED_ORDER =
  "SET_SHIPING_LIST_UN_DELIVERED_ORDER";
export const SET_SHIPING_LIST_OUT_FOR_DELIVEREY_ORDER =
  "SET_SHIPING_LIST_OUT_FOR_DELIVEREY_ORDER";
export const SET_SHIPING_LIST_RETURN_TO_SHIPPER_ORDER =
  "SET_SHIPING_LIST_RETURN_TO_SHIPPER_ORDER";
export const SHIPING_LIST_ORDER_ERROR = "SHIPING_LIST_ORDER_ERROR";

export const setDeliveredOrderCount = (data) => {
  return {
    type: SET_DELIVERED_ORDER_COUNT,
    payload: data
  };
};

export const setUnDeliveredOrderCount = (data) => {
  return {
    type: SET_UN_DELIVERED_ORDER_COUNT,
    payload: data
  };
};

export const setReturnedOrderCount = (data) => {
  return {
    type: SET_RETURN_TO_SHIPPER_ORDER_COUNT,
    payload: data
  };
};

export const getOrderCountByStatus = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ORDER_COUNT_BY_STATUS });
    const countType = filter.countType;
    delete filter.countType;

    try {
      const res = await API.post(CLIENT_DASHBOARD, filter);

      if (countType === "DELIVERED") {
        dispatch(setDeliveredOrderCount(res.data));
      } else if (countType === "RETURNED") {
        dispatch(setReturnedOrderCount(res.data));
      } else if (countType === "PENDING") {
        dispatch(setUnDeliveredOrderCount(res.data));
      }

      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

export const setShipingList = (data) => {
  return {
    type: SET_SHIPING_LIST_ORDER,
    payload: data
  };
};

export const getShipingList = (data) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST_ORDER });
    try {
      const res = await API.post(CLIENT_DASHBOARD, data);
      dispatch(setShipingList(res.data));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

// @TODO: check this code is required otherwise delete this code.

// export const deliveredShipingList = (params) => {
//   return async (dispatch) => {
//     dispatch({ type: REQUEST_SHIPING_LIST_ORDER });
//     try {
//       const res = await API.get(CLIENT_DASHBOARD_DELIVERED_COUNT, {
//         params
//       });
//       dispatch(setShipingList(res));
//       return res;
//     } catch (error) {
//       console.log(error);
//       dispatch(setError('Somehing went wrong!'));
//     }
//   };
// };

// export const setUnDeliveredShipingList = (data) => {
//   return {
//     type: SET_SHIPING_LIST_UN_DELIVERED_ORDER,
//     payload: data
//   };
// };

// export const unDeliveredShipingList = (params) => {
//   return async (dispatch) => {
//     dispatch({ type: REQUEST_SHIPING_LIST_ORDER });
//     try {
//       const res = await API.get(CLIENT_DASHBOARD_UN_DELIVERED_COUNT, {
//         params
//       });
//       dispatch(setUnDeliveredShipingList(res));
//       return res;
//     } catch (error) {
//       console.log(error);
//       dispatch(setError('Somehing went wrong!'));
//     }
//   };
// };

export const setOutForDeliveryShipingList = (data) => {
  return {
    type: SET_SHIPING_LIST_OUT_FOR_DELIVEREY_ORDER,
    payload: data
  };
};

export const outForDelivereyShipingList = (params) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST_ORDER });
    try {
      const res = await API.get(CLIENT_DASHBOARD_OFD_COUNT, {
        params
      });
      dispatch(setOutForDeliveryShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

// export const setReturnToShipper = (data) => {
//   return {
//     type: SET_SHIPING_LIST_RETURN_TO_SHIPPER_ORDER,
//     payload: data
//   };
// };

// export const returnToShipperShipingList = (params) => {
//   return async (dispatch) => {
//     dispatch({ type: REQUEST_SHIPING_LIST_ORDER });
//     try {
//       const res = await API.get(CLIENT_DASHBOARD_RTS_COUNT, {
//         params
//       });
//       dispatch(setReturnToShipper(res));
//       return res;
//     } catch (error) {
//       console.log(error);
//       dispatch(setError('Somehing went wrong!'));
//     }
//   };
// };

const initialState = {
  isLoading: false,
  loaded: false,
  error: null,
  deliveredOrderCount: 0,
  unDeliveredOrderCount: 0,
  returnToShipperOrderCount: 0
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_ORDER_COUNT_BY_STATUS:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_DELIVERED_ORDER_COUNT:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        deliveredOrderCount: payload.count
      };
    case SET_UN_DELIVERED_ORDER_COUNT:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        unDeliveredOrderCount: payload.count
      };
    case SET_RETURN_TO_SHIPPER_ORDER_COUNT:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        returnToShipperOrderCount: payload.count
      };
    case REQUEST_SHIPING_LIST_ORDER:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_SHIPING_LIST_ORDER:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case SHIPING_LIST_ORDER_ERROR:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        error: payload.error
      };

    default:
      return state;
  }
}
